import { sub } from "date-fns";

export class CTeFilter {
    status: string = '';
    statusLabel: string = 'Todos';
    numDoc: string = "";
    docTomador: string = "";
    vlrMinCt: number | null = null;
    vlrMaxCt: number | null = null;
    serie: string = "";
    chaveCt: string = "";
    branchesIds: string | null = null;
    branchesCodes: string | null = null;
    companyId: number | null = null;
    ids: string = "";

    initialDateObj?: Date = sub(new Date(), { months: 1 });
    finalDateObj?: Date = new Date();
}
